import * as React from 'react';
import {withTranslation} from "react-i18next";

const LoadingCircles = (props) => {
    return (
        <div id="loading-overlay">
            <span>{props.t('LOADING_TEXT')}</span>
            <div>
                <div className="outer">
                    <div className="dot"></div>
                    <div className="dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation('common')(LoadingCircles);